import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DubaiVisaGuard implements CanActivate {
  constructor(private _router: Router) { }
  visaUserType: string = "";

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if(localStorage.getItem('adminUser')){
        this.visaUserType = "adminUser";
        return true;
      }else{
        this._router.navigate(['/']);
        return false;
      }
  }
}
